import * as classnames from 'classnames';
import * as React from 'react';

import Dropzone from 'react-dropzone';

import { FormattedMessage } from 'react-intl';
import { change, WrappedFieldProps } from 'redux-form';

import './InputFile.scss';

export interface InputFileImage extends File {
  preview?: string;
}

export interface InputFileProps {
  className?: string;
  label: string;
  icon?: string;
}

interface InputFileState {
  selectedImageFile?: InputFileImage;
}

export class InputFile extends React.Component<InputFileProps & WrappedFieldProps, InputFileState> {
  constructor(props: InputFileProps & WrappedFieldProps) {
    super(props);

    this.state = { selectedImageFile: undefined };
    this.onFileSelected = this.onFileSelected.bind(this);
  }

  componentWillMount() {
    const { input } = this.props;
    if (input.value) {
      this.setState({ selectedImageFile: input.value });
    }
  }

  componentWillReceiveProps(nextProps: InputFileProps & WrappedFieldProps) {
    if (nextProps.input.value && this.props.input.value !== nextProps.input.value) {
      this.setState({ selectedImageFile: nextProps.input.value });
    }
  }

  render() {
    const { className, icon, input, label, meta } = this.props;
    const labelClassNameModifier = this.state.selectedImageFile && 'input-file__label--preview-visible';
    const iconClassNameModifier = this.state.selectedImageFile && 'input-file__icon--preview-visible';
    const footnoteErorrClassNameModifier = meta.error && 'input-file__footnote--is-error';

    return (
      <Dropzone
        className={classnames('input-file__container', className)}
        name={input.name}
        accept="image/*"
        multiple={false}
        onDrop={this.onFileSelected}
      >
        <div className="input-file__select">
          {this.selectedImagePreview}
          {icon && <i className={classnames('input-file__icon', iconClassNameModifier, icon)} />}
          <p className={classnames('input-file__label', labelClassNameModifier)}>{label}</p>
        </div>
        <p className="input-file__footnote">
          {meta.error && <span className={classnames(footnoteErorrClassNameModifier)}><FormattedMessage id={meta.error}/></span>}
        </p>
      </Dropzone>
    );
  }

  get selectedImagePreview() {
    const { selectedImageFile } = this.state;
    if (selectedImageFile && selectedImageFile.preview) {
      return (
        <img src={selectedImageFile.preview} className="input-file__preview" />
      );
    }
    return null;
  }

  private onFileSelected(selectedFiles: InputFileImage[]) {
    const { input, meta } = this.props;
    meta.dispatch(change(meta.form, input.name, selectedFiles[0]));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputFile/InputFile.tsx